import type { MailboxInbox } from '@recruitee/mailbox-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } =
  createEntityCollectionStore<MailboxInbox>()('mailbox-inboxes');

export {
  actions as MailboxInboxesActions,
  reducer as MailboxInboxesReducer,
  namespace as MailboxInboxesNamespace,
  selectors as MailboxInboxesSelectors,
};
